import { Checkbox } from '@mantine/core';
import { capitalizeEachFirstLetter } from '@zorro/shared/formatters';
import { Flex, Grid, Text } from '@zorro/web/design-system';

import classNames from './PlanFilter.module.scss';

type Props<T extends string> = {
  filterValues: T[];
  filterOptions: Set<T> | undefined;
  selectedFilters: string[];
};

export const BooleanFilters = <T extends string>({
  filterValues,
  filterOptions,
  selectedFilters,
}: Props<T>) => {
  if (!filterOptions) {
    return null;
  }

  return (
    <Grid columns={2} gap="sm">
      {filterValues.map((filter) => {
        if (filterOptions.has(filter)) {
          return (
            <Grid.Col key={filter} span={1}>
              <Checkbox.Card
                checked={selectedFilters?.includes(filter)}
                value={filter}
                className={classNames.checkboxCard}
              >
                <Flex p="md" align="center" gap="xs" h="3rem" justify="center">
                  <Text>{capitalizeEachFirstLetter(filter)}</Text>
                </Flex>
              </Checkbox.Card>
            </Grid.Col>
          );
        }
        return null;
      })}
    </Grid>
  );
};
